import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import DefaultLayout from './Layouts/DefaultLayout';
import PermsError from './Errors/PermsError';
import AppComp from './App';
import XapInterstitial from './XapInterstitial';
import GenericError from './Errors/GenericError';
import ErrorBoundary from '../components/ErrorBoundary';
import LoadingWrapper from '../components/LoadingWrapper';

import { getAuth, addRefreshAuthListener } from '../actions/auth';
import { getAccount } from '../actions/account';
import featureFlags from '../helpers/featureFlags';
import ExtendSessionDialog from '../components/ExtendSessionDialog';
import { isAptEnabled } from '../helpers/auth';
import { ACCOUNT_SWITCHER, SWAPS, withQuery } from '../helpers/routes';
import { getBillPayAccounts } from '../helpers/account';

class Auth extends Component {
  constructor() {
    super();

    this.state = {
      featureFlagsReady: false,
    };
  }

  async componentDidMount() {
    const {
      handleGetAuth,
      handleGetAccount,
      handleAddRefreshAuthListener,
    } = this.props;

    await featureFlags.onReady(() => {
      this.setState({
        featureFlagsReady: true,
      });
    });

    // Wait for authentication to complete
    await handleGetAuth();

    // Only call getAccount if user is authenticated
    const { auth, history, location } = this.props;
    // If status is not in props, try to get from window.__PRELOADED_STATE__ or skip
    const isAuthenticated = auth && auth.status === 'LOGIN FULL';
    if (isAuthenticated) {
      handleGetAccount();
    }

    // When APT is disabled and the user has multiple billpay accounts,
    // redirect to the in-app account selector on initial load.
    // Only show for equipment-update pages that require account selection.
    if (
      !isAptEnabled()
      && isAuthenticated
      && !auth.hasSelectedAccount
      && location.pathname.startsWith(SWAPS)
    ) {
      const macaroon = auth.macaroon || {};
      const accounts = macaroon.accounts || [];
      const billPayAccounts = getBillPayAccounts(accounts);
      if (billPayAccounts.length > 1) {
        const continueUrl = `${location.pathname}${location.search}`;
        history.push(withQuery(ACCOUNT_SWITCHER, { continueUrl }));
      }
    }

    handleAddRefreshAuthListener();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location !== prevProps.location) {
      // a11y
      const content = document.getElementById('page-content');
      if (content) {
        content.focus();
      }
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { featureFlagsReady } = this.state;

    const {
      loading, permsError, isLite, redirect, error,
    } = this.props;

    if (loading || !featureFlagsReady || redirect) {
      return <LoadingWrapper />;
    }

    if (error) {
      return (
        <div className="page-app">
          <DefaultLayout component={GenericError} isLite={isLite} />
        </div>
      );
    }

    if (permsError) {
      return (
        <div className="page-app">
          <DefaultLayout component={PermsError} isLite={isLite} />
        </div>
      );
    }

    return (
      <ErrorBoundary>
        <AppComp {...this.props} />
        <XapInterstitial />
        <ExtendSessionDialog />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({
  auth,
  account,
}) => ({
  loading: (auth && auth.loading) || (account && account.loading),
  redirect: auth && auth.redirect,
  error: (auth && auth.error) || (account && account.error),
  permsError: auth && auth.permsError,
  isLite: auth && auth.lite,
  auth,
  account,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleGetAuth: getAuth,
  handleGetAccount: getAccount,
  handleAddRefreshAuthListener: addRefreshAuthListener,
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Auth));
